import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './page/home/home.component';
import { ProjectComponent } from './page/project/project.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ContactUsComponent } from './page/contact-us/contact-us.component';
import { FacilitiesComponent } from './page/facilities/facilities.component';
import { AboutUsComponent } from './page/about-us/about-us.component';
import { OurServiceComponent } from './page/our-service/our-service.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { CareerComponent } from './page/career/career.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProjectComponent,
    HeaderComponent,
    FooterComponent,
    ContactUsComponent,
    FacilitiesComponent,
    AboutUsComponent,
    OurServiceComponent,
    CareerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {

  public supportLang = ['en','cn'];

  constructor(
    public translate: TranslateService
  ){
    translate.setDefaultLang('en');
    // translate.addLangs(this.supportLang);
    // if(this.supportLang.includes(window.navigator.language.substring(0,2))){
    //   translate.setDefaultLang(window.navigator.language.substring(0,2));
    // }else{
    //   translate.setDefaultLang('cn');
    // }
  }

  swicthLang(lang:string){
    this.translate.setDefaultLang(lang);
  }
}

export function httpTranslateLoader(http: HttpClient){
  return new TranslateHttpLoader(http)
}